// src/pages/admin/Referrals.jsx
import React, { useEffect, useState } from "react";
import { getReferrals, updateReferral } from "../../lib/db";
import { TableCard, Table, Badge, Btn, Select, Toast, Spinner, fmtDate, fmt$ } from "../../components/UI";

export default function Referrals() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [toast, setToast]         = useState("");

  const load = async () => { setLoading(true); setReferrals(await getReferrals()); setLoading(false); };
  useEffect(() => { load(); }, []);

  const handleStatus = async (id, status) => {
    await updateReferral(id, { status });
    setToast("Referral updated."); setTimeout(() => setToast(""), 3000);
    load();
  };

  const cols = [
    { key:"designer", label:"From Designer" },
    { key:"client", label:"Client / Project" },
    { key:"budget", label:"Est. Budget" },
    { key:"notes", label:"Notes" },
    { key:"statusBadge", label:"Status" },
    { key:"date", label:"Submitted" },
    { key:"actions", label:"" },
  ];

  const rows = referrals.map(r => ({
    designer: r.designerName || "—",
    client: r.clientName,
    budget: fmt$(r.budget),
    notes: r.notes ? <span style={{fontSize:11,color:"var(--mid)"}}>{r.notes.slice(0,50)}{r.notes.length>50?"…":""}</span> : "—",
    statusBadge: <Badge label={r.status || "new"} />,
    date: fmtDate(r.createdAt),
    actions: (
      <Select value={r.status || "new"} onChange={e => handleStatus(r.id, e.target.value)}
        style={{ fontSize:11, padding:"5px 10px", width:120 }}>
        <option value="new">New</option>
        <option value="contacted">Contacted</option>
        <option value="active">Active Order</option>
        <option value="closed">Closed</option>
      </Select>
    ),
  }));

  return (
    <div>
      <Toast msg={toast} onClose={() => setToast("")} />
      <div style={{ padding:"36px 48px 0" }}>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:300 }}>Referrals</h1>
        <p style={{ fontSize:13, color:"var(--mid)", marginTop:4 }}>Designer-submitted client referrals</p>
      </div>
      <div style={{ padding:"24px 48px 48px" }}>
        <TableCard title={`Referrals (${referrals.length})`}>
          {loading ? <Spinner /> : <Table cols={cols} rows={rows} emptyMsg="No referrals submitted yet." />}
        </TableCard>
      </div>
    </div>
  );
}
